const order = [
    {
        path: '/system',
        name: 'system.menu',
        component: () => import('@/views/system/SystemMenu.vue'),
        meta: {
            env:['production'],
            pageTitle: 'Opções do Sistema',
            roles: [5,],
        },
    },
    {
        path: '/system/queues',
        name: 'system.queues.list',
        component: () => import('@/views/system/QueuesList.vue'),
        meta: {
            env:['production'],
            pageTitle: 'Status da Fila',
            roles: [5],
        },
    },
    {
        path: '/system/last-sync',
        name: 'system.last-sync.list',
        component: () => import('@/views/system/LastSynchronization.vue'),
        meta: {
            env:['production'],
            pageTitle: 'Dados de Sincronização',
            roles: [5],
        },
    },
    {
        path: '/system/jobs',
        name: 'system.job.list',
        component: () => import('@/views/system/JobList.vue'),
        meta: {
            env:['production'],
            pageTitle: 'Processos no Fila',
            roles: [5],
        },
    },

]

export default order
